import React from "react";
import { HiArrowRight, HiXMark } from "react-icons/hi2";
import "../../styles/trial-banner.css";

/**
 * Faixa laranja do período de teste (RSL - 060, "Ação 1"): aparece no topo da
 * área de conteúdo durante os primeiros dias de cadastro. Clicar nela leva à
 * escolha de plano (`onChoose`); o "x" (`onDismiss`) a remove.
 *
 * Visual em `styles/trial-banner.css` (a animação de hover do "Escolha o
 * plano" acontece ao passar o mouse na faixa inteira).
 */
export default function TrialPlanBanner({ daysLeft = null, onChoose, onDismiss }) {
  const showDays = Number.isFinite(daysLeft) && daysLeft > 0;
  return (
    <div className="rs-trial-banner" role="region" aria-label="Período de teste">
      <button
        type="button"
        className="rs-trial-banner__main"
        onClick={onChoose}
      >
        <span className="rs-trial-banner__text">
          Versão de teste: escolha seu plano para usar 100% do sistema.
          {showDays ? (
            <small>
              {daysLeft === 1 ? "Resta 1 dia" : `Restam ${daysLeft} dias`}
            </small>
          ) : null}
        </span>
        <span className="rs-trial-banner__cta">
          Escolha o plano
          <HiArrowRight aria-hidden="true" />
        </span>
      </button>
      <button
        type="button"
        className="rs-trial-banner__close"
        onClick={onDismiss}
        aria-label="Dispensar aviso"
        title="Dispensar"
      >
        <HiXMark aria-hidden="true" />
      </button>
    </div>
  );
}
